export const stepsData = [
    {
        title: 'Achou um bom cupom?',
        description: 'Clique em "Pegar Cupom". Ao clicar, uma janela será aberta.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/cupom_passo_1.png',
    },
    {
        title: 'Copie o código',
        description: 'Dentro da janela, clique no botão "Copiar" e o código do cupom fica pronto para ser colado no carrinho de compras.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/cupom_passo_2.png',
    },
    {
        title: 'Ir para o site',
        description: 'Dentro da janela, clique no botão "Ir para o site".',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/cupom_passo_3.png',
    },
    {
        title: 'Compra',
        description: 'No carrinho de compras da loja, cole o código no campo de cupom/vale e finalize sua compra.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/cupom_passo_4.png',
    },
];